import { render } from "./OrderTableCoord.vue?vue&type=template&id=545269af"
import script from "./OrderTableCoord.vue?vue&type=script&lang=js"
export * from "./OrderTableCoord.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/apps/crm/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__